import { getTrackingService, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { UPDATE_USER_STATUS } from '@gig/magic-messages';
import { ESubmitState } from '@gig/magic-form-builder';

var CorexUserDetails = /** @class */ (function (_super) {
    __extends(CorexUserDetails, _super);
    function CorexUserDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submitState = ESubmitState.PRE_SUBMIT;
        return _this;
    }
    CorexUserDetails.prototype.onSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var submitData;
            return __generator(this, function (_a) {
                if (this.submitState === ESubmitState.SUBMITTING) {
                    return [2 /*return*/];
                }
                this.submitState = ESubmitState.SUBMITTING;
                submitData = event.detail[0];
                this.$emit('submitData', submitData);
                return [2 /*return*/];
            });
        });
    };
    CorexUserDetails.prototype.updateUserProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.submittedData) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, magic.methods.users.updateUserProfile(this.submittedData)];
                    case 2:
                        _b.sent();
                        getTrackingService().trackUpdateProfile();
                        return [4 /*yield*/, window.commandBus.publish(UPDATE_USER_STATUS)];
                    case 3:
                        _b.sent();
                        this.submitState = ESubmitState.SUBMITTING;
                        this.$emit('close');
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        this.submitState = ESubmitState.POST_SUBMIT_ERROR;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: Array }),
        __metadata("design:type", Array)
    ], CorexUserDetails.prototype, "formConfig", void 0);
    __decorate([
        Prop({ type: Object }),
        __metadata("design:type", Object)
    ], CorexUserDetails.prototype, "initialFormState", void 0);
    __decorate([
        Prop({ type: Object }),
        __metadata("design:type", Object)
    ], CorexUserDetails.prototype, "submittedData", void 0);
    __decorate([
        Watch('submittedData'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CorexUserDetails.prototype, "updateUserProfile", null);
    CorexUserDetails = __decorate([
        Component({
            name: 'corex-user-details',
        })
    ], CorexUserDetails);
    return CorexUserDetails;
}(Mixins(MagicConfigMixin)));

export default CorexUserDetails;
